var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    _vm._l(_vm.datasFileAttente, function(dataVisiteurAttente, i) {
      return _c(
        "v-flex",
        {
          key: i,
          staticClass: "xs12",
          class: {
            md6: _vm.pupitreViewStatus == 2,
            md4: _vm.pupitreViewStatus == 1
          }
        },
        [
          _c("wz-visiteur-attente", {
            attrs: {
              visiteur: dataVisiteurAttente,
              pupitreData: _vm.pupitreData
            },
            on: {
              supVisiteurFile: function($event) {
                return _vm.$emit("supVisiteurFile", $event)
              }
            }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aac0690", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aac0690","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzViewAttente.vue
// module id = null
// module chunks = 